export class FactorDetail {
  public constructor() {
    this.files = [];
    this.drugs = [];
    this.returnDrug=[];
  }

  public id?: string;
  public totalPrice?: number;
  public companyId?: string;
  public paymentId?: string;
  public factorId?: string;
  public factorDate?: string;
  public deliveryDate?: string;
  public discount?: number;
  public sellerId?: string;
  public description?: string;
  public state?: number;
  public companyName?: string;
  public files: any[];
  public drugs: FactorDetailDrug[];
  public returnDrug:FactorStockItemDetailDrug[];
  public haveBuyReturn?: boolean;
  public haveShortage?: boolean;

}

export class FactorDetailDrug {
  public constructor() {
    this.inventoryDetails = [];
    this.buyReturns = [];
  }

  public drugId?: string;
  public id?: string;
  public count?: number;
  public shortageCount?: number;
  public expireDate?: string;
  public lot?: string;
  public complimentary?: number;
  public buyPrice?: number;
  public sellPrice?: number;
  public onlinePrice?: number;
  public partnerPrice?: number;
  public inventoryDetails: any[];
  public buyReturns: any[];
  public minimumDigitalCount?: number;
  public minimumCount?: number;
  public buyDiscountPersent?: number;
  public buyDiscount?: number;
  public buyGift?: number;
  public drugName?: string;
  public tax?: number;
  public totalPrice?: number;
  public returnCount?: number;
  public packageCount?: number;
  public isSelected:boolean=false;
}


export class FactorStockItemDetailDrug {
  public constructor() {
  }

  public count?: number;
  public buyFactorDetailId?:string;
  public stockItemId?: string;
  public buyFactorNumber?:string;
  public description?:string;
  public liveLack:number|undefined;

  public alertMessage?: string;
  public inventory?: number;
  public drugId?: string;
  public shortageCount?: number;
  public expireDate?: string;
  public lot?: string;
  public complimentary?: number;
  public buyPrice?: number;
  public sellPrice?: number;
  public onlinePrice?: number;
  public partnerPrice?: number;
  public minimumDigitalCount?: number;
  public minimumCount?: number;
  public buyDiscountPersent?: number;
  public buyDiscount?: number;
  public buyGift?: number;
  public drugName?: string;
  public tax?: number;
  public totalPrice?: number;
  public returnCount?: number;
  public packageCount?: number;
  public isSelected:boolean=false;
  public stocks:any[]=[];
}

